import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function NetworkStatusBanner() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(() => typeof navigator === "undefined" || navigator.onLine);

  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);

  if (online) return null;
  return <div className="network-status-banner" role="status">{t("pwa.offline")}</div>;
}
